







































































































































import { TbMember, TbReturnOrder } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import { counter } from "@/components";
import dayjs from "dayjs";
@Component({
    components: {
        counter
    },
})
export default class selectReturnProduct extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        type:Object,
        default:()=>{
            return{
                items:[]
            }
        }
    })
    form:any;
    @Prop({
        type:Object,
        default:()=>{
            return{
                num:0,
                returnOrderNo:''
            }
        }
    })
    oldReturnedInfo:any;

    list=[];

    fmoney = fmoney;

    /**选中的退回商品 */
    selectedList = [];

    /**支付方式 */
    get payName(){
        let str = "";
        if(this.form.paymentMethod){
            switch (this.form.paymentMethod) {
                case 1:
                    str="会员卡"
                    break;
                case 2:
                    str="现金"
                    break;
                case 3:
                    str="微信"
                    break;
                case 4:
                    str="支付宝"
                    break;
                case 5:
                    str="现金+会员卡+微信"
                    break;
                case 6:
                    str="现金+会员卡+支付宝"
                    break;
                case 7:
                    str="现金+微信"
                    break;
                case 8:
                    str="现金+支付宝"
                    break;
                case 9:
                    str="会员卡+微信"
                    break;
                case 10:
                    str="会员卡+支付宝"
                    break;
                case 11:
                    str="现金+会员卡"
                    break;
                    case 13:
                    str="线下微信"
                    break;
                case 14:
                    str="线下支付宝"
                    break;
                case 15:
                    str="现金+线下支付宝"
                    break;
                case 16:
                    str="会员卡+线下支付宝"
                    break;
                case 17:
                    str="现金+线下微信"
                    break;
                case 18:
                    str="会员卡+线下微信"
                    break;
                case 19:
                    str="线下微信+线下支付宝"
                    break;
                case 20:
                    str="现金+会员卡+线下支付宝"
                    break;
                case 21:
                    str="现金+会员卡+线下微信"
                    break;
                case 22:
                    str="现金+线下支付宝+线下微信"
                    break;
                case 23:
                    str="会员卡+线下支付宝+线下微信"
                    break;
            
                default:
                    break;
            }
        }
        return str;
    }
    /**退回数量 */
    get returnNumAll(){
        let val = 0;
        let arr = this.form.items.filter(v=>v.checked&&Number(v.newReturnNum)>0).map(v=>v.newReturnNum);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)))
        }
        return val;
    }

    get isDateMoreThanOneYearOld() {
        let val = false;
        if(this.form.createTime){
            const targetDate = dayjs(this.form.createTime);
            const currentDate = dayjs(); // 获取当前日期
            const difference = currentDate.diff(targetDate, 'day'); // 计算年份差异
            val = difference>365
        }
        return val; // 如果差异大于1年，则返回true
    }
    /**退回金额 */
    returnPriceAll =0;

    calcReturnInfo:any = {
        items:[],
    };

    created() {
    }   
    
    mounted() {
       
    }

    closeFun(){
        this.$emit('closeFun');
    }
    /**计算折扣 */
    getDiscount(item){
        let str = "";
        let val = null;
        let finalPrice = item.finalPrice?item.finalPrice:0;
        let sellingPrice = item.sellingPrice?item.sellingPrice:0;
        val = finalPrice? calculate.multiplication(calculate.division(finalPrice,sellingPrice,2,true),100):0;
        str = val+"%"
        return str;
    }
    /**计算原价 */
    getSellingPrice(item){
        let str = "";
        let val = null;
        val = calculate.multiplication(item.sellingPrice,item.num);
        str = fmoney(val,2,true);
        return str;
    }
    /**计算实际售价 */
    getFinalPrice(item){
        let str = "";
        let val = null;
        val = calculate.multiplication(item.finalPrice,item.num);
        str = fmoney(val,2,true);
        return str;
    }
    /**计数器 */
    finishStep(val,index){
        this.$set(this.form.items[index],'newReturnNum',Number(val));
        let item = this.form.items[index];
        this.$nextTick(()=>{
            if(Number(this.form.items[index].newReturnNum)>Number(item.returnNum)){
                this.$set(this.form.items[index],'newReturnNum',Number(item.returnNum));
            }
            this.getReturnOrderInfo();
        })
    }
    /**计数器加-验证 */
    chargeAdd(item){
        let val = false;
        if(Number(item.returnNum)<=0||Number(item.returnNum)==Number(item.newReturnNum)){
            val = true;
        }
        return val;
    }
    /**确定退回 */
    confirmReturn(){
        let list = this.form.items.filter(v=>v.checked&&Number(v.newReturnNum)>0)
        let obj = Object.assign({},this.form,{calcReturnInfo:this.calcReturnInfo})
        this.$emit("confirmReturn",obj);
    }
    /**整单退回 */
    async returnAll(){
      
        let res = await TbReturnOrder.GetReturnOrderInfo({
            orderId:this.form.id,
            items:this.form.items.filter(v=>Number(v.returnNum)>0).map(v=>{
                return{
                    goodsItemId:v.goodsItemId,
                    num:v.returnNum,
                    isGift:v.isGift
                }
            })
        })
        let obj = Object.assign({},this.form,{calcReturnInfo:res})
        this.$emit("returnAll",obj);
    }
    async checkChange(item,index){
        if(item.returnNum<=0) return;
        if(item.checked&&!item.newReturnNum){
            this.$set(this.form.items[index],'newReturnNum',item.returnNum);
            await this.getReturnOrderInfo();
        }else{
            await this.getReturnOrderInfo();
        }
    }
    async getReturnOrderInfo(){
        let res = await TbReturnOrder.GetReturnOrderInfo({
            orderId:this.form.id,
            items:this.form.items.filter(v=>v.checked&&Number(v.newReturnNum)>0).map(v=>{
                return{
                    goodsItemId:v.goodsItemId,
                    num:v.newReturnNum,
                    isGift:v.isGift
                }
            })
        })
        this.returnPriceAll = res.refundable;
        this.calcReturnInfo = res;
    }

   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/selectReturnProduct.vue